import actions from 'modules/order/generateTag/orderGenerateTagActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.GENERATE_TAG_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.GENERATE_TAG_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.GENERATE_TAG_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.GENERATE_TAG_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.GENERATE_TAG_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.GENERATE_TAG_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};

